var PlayerPage =  function() {
    const initPlayerDataToggle = function() {
        $('.ii__player-data-toggle').click(function(e) {
            const btn = $(e.currentTarget),
                btnInnerSpan = $(btn).find('span'),
                iSymbol = $(btn).find('i.icon'),
                iSymbolOpen = iSymbol.hasClass('fa-angle-up'),
                currentTxt = btnInnerSpan.text(),
                newTxt = currentTxt === 'Περισσότερα' ? 'Λιγότερα' : 'Περισσότερα',
                newClass = iSymbolOpen ? 'fa-angle-down' : 'fa-angle-up';
            btnInnerSpan.text(newTxt);
            iSymbol.removeClass('fa-angle-down fa-angle-up');
            iSymbol.addClass(newClass);
        });
    };

    return {
        init: function() {
            initPlayerDataToggle();
            Generic.init_popovers();

            $('.ii__player_stats_team_selector').click(function() {
                const btn = $(this),
                    type = btn.data('type')
                ;
                $('.ii__player_stats').addClass('d-none');
                $(`#player_stats_${type}`).removeClass('d-none');
                $('.ii__player_stats_team_selector').removeClass('abox__btn--active');
                btn.addClass('abox__btn--active');
            });
        }
    };
}();
